<template>
  <div class="column content-box full_page llm_pg_container">
    <woot-button
      color-scheme="success"
      class-names="button--fixed-right-top"
      icon="add-circle"
      @click="goAddLLM"
    >
      <!-- :disabled="" -->
      {{ $t('CAMPAIGN.LLM_CHATBOT.ADD_LLM_CHATBOT') }}
    </woot-button>
    <div class="llm_container">
      <InputField
        :placeholder="$t('CAMPAIGN.LLM_CHATBOT.LIST.SEARCH.LABEL')"
        class="mt_20"
        @enter="onInputSearch"
      />
      <div class="llm_chatbot_list_header my_20 mt_30 px_12">
        <h1
          class="font_regular text_16 font_600 text_center text_black_secondary"
        >
          {{ $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.LLM_NAME') }}
        </h1>
        <h1
          class="font_regular text_16 font_600 text_center text_black_secondary"
        >
          {{ $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.LLM_STATUS') }}
        </h1>
        <h1
          class="font_regular text_16 font_600 text_center text_black_secondary"
        >
          {{ $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.LLM_MODEL') }}
        </h1>
        <h1
          class="font_regular text_16 font_600 text_center text_black_secondary"
        >
          {{ $t('CAMPAIGN.LLM_CHATBOT.LIST.TABLE.LLM_ACTION') }}
        </h1>
      </div>
      <ul class="llm_chatbot_list">
        <LLMcard
          v-for="chatbot in formattedLLmBots"
          :key="chatbot.id"
          :chatbot="chatbot"
          @onDelete="onDeleteChatbot"
        />
      </ul>
    </div>
    <DeleteModal
      :show="!!delete_llmbot"
      :title="'Are you sure to delete it?'"
      :on-confirm="onConfirmDelete"
      :on-close="onCloseDeleteModal"
      :confirm-text="$t('COUPON.DELETE_MODAL.CONFIRM_BTN')"
      :reject-text="$t('COUPON.DELETE_MODAL.REJECT_BTN')"
    />
  </div>
</template>

<script>
import InputField from 'components/ui/inputs/InputField.vue';
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import LLMcard from './LLMcard.vue';
import DeleteModal from 'components/widgets/modal/DeleteModal.vue';

export default {
  components: {
    InputField,
    LLMcard,
    DeleteModal,
  },
  mixins: [alertMixin],

  data() {
    return {
      delete_llmbot: null,
      searchText: '',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getAccount: 'accounts/getAccount',
      uiFlags: 'llmbots/getUIFlags',
      llm_bots: 'llmbots/getLLMBots',
    }),
    currentAccount() {
      return this.getAccount(this.currentUser.account_id) || {};
    },
    formattedLLmBots() {
      // return this.llm_bots;
      const search = this.searchText.trim().toLowerCase();
      if (!search) return this.llm_bots;

      return this.llm_bots.filter(bot =>
        bot.name.toLowerCase().includes(search)
      );
    },
  },
  mounted() {
    this.$store.dispatch('llmbots/fetchLLMBots');
  },
  methods: {
    onDeleteChatbot(chatbot) {
      this.delete_llmbot = chatbot;
    },
    async onConfirmDelete() {
      try {
        this.$store.dispatch('llmbots/deleteLLMbotById', {
          llm_bot_id: this.delete_llmbot?.id,
        });
        this.showAlert(
          this.$t('CAMPAIGN.LLM_CHATBOT.ADD.SUBMIT_ACTION.DELETE_SUCCESS')
        );
        this.onCloseDeleteModal();
      } catch (error) {
        this.showAlert(
          error.response?.data?.message ||
            this.$t('CAMPAIGN.LLM_CHATBOT.ADD.SUBMIT_ACTION.ERROR')
        );
      }
    },
    onCloseDeleteModal() {
      this.delete_llmbot = null;
    },
    goAddLLM() {
      this.$router.push({
        name: 'llm_bot_add',
      });
    },
    onInputSearch(value) {
      this.searchText = value;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/widgets/_fonts.scss';
@import '~dashboard/assets/scss/woot';

.llm_pg_container {
  min-height: 86vh;
}

.llm_container {
  max-width: 100%;
  margin: auto;
  @include breakpoint(medium up) {
    width: 75%;
  }
}
.llm_chatbot_list_header {
  display: grid;
  grid-template-columns: 1fr 100px 50px 50px;
  gap: 10px;
  @include breakpoint(medium up) {
    grid-template-columns: 1fr 200px 150px 110px;
  }
}
.llm_chatbot_list {
  list-style: none;
  margin: 0;
}
</style>
